import styled from 'styled-components';
import { brand, darkgrey, dot, grey, white } from 'styles/Colors';
export const CircleWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Circle = styled.div`
  content: '';
  width: 24px;
  height: 24px;
  border: 1px solid ${dot};
  border-radius: 25px;
`;
export const RadioButtonWithTextWrapper = styled.div`
  position: relative;
  max-width: 444px;
  width: 100%;
  padding: 16px;
  border-radius: 5px;
  background-color: ${white};
  font-family: Lato;
  font-size: 15px;
  line-height: 1.07;
  letter-spacing: 0.5px;
  color: ${darkgrey};
  display: flex;
  gap: 12px;
  cursor: pointer;
  border: solid 1px #e0e0e0;
  align-items: center;

  &.checked {
    border: solid 1px ${brand};
    ${CircleWrapper} {
      ${Circle} {
        border: 1px solid ${brand};
        &:after {
          content: '';
          position: absolute;
          height: 15px;
          width: 15px;
          background: #ec691a;
          border-radius: 25px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  &.disabled {
    color: ${grey};
    cursor: default;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  letter-spacing: 0%;
`;

export const Title = styled.div`
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18.2px;
`;

export const RadioButtonGroup = styled.div``;

export const Text = styled.div`
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
`;
